import events from '../events';
import { session } from './session';
import { NotificationManager } from 'react-notifications';
import { ModuleRP } from '../components/ModRP';
import { _$, _setText } from './dom';
import { locales } from '../translations/locales';
import { readCookie } from './cookies';

const socketManage = async (socket) => {
    /*
    ** Init Socket
    */
    socket.on('connect', () => {
        socket.emit(events.PING, socket.id, readCookie('_asid') ? readCookie('_asid').split(',')[0] : 'visitor');
    });

    socket.on('disconnect', () => {
        if (ModuleRP.Bip && ModuleRP.Bip.on) ModuleRP.Bip.newMessage({ date: new Date(), text: 'DISCONNECTED' });
        if (ModuleRP.Radio && ModuleRP.Radio.on) {
            ModuleRP.Radio.newMessage('[[bip.disconnected]]');
        }
    });

    socket.on(events.CONNECT_ERROR, () => {
        if ((_$('modalSocket') && _$('modalSocket').style.display === 'block') || session.devMod) {
            return;
        }
        const openModal = () => {
            const modals = document.getElementsByClassName('modal');
            for (const i in modals) {
                if (typeof (modals[i]) == 'object' && modals[i].id === 'modalSocket') {
                    const modal = modals[i];
                    modal.style.backgroundColor = 'rgba(0,0,0,0.5)';
                    modal.style.display = 'block';
                    _setText('modalSocket-body', `${locales[readCookie('lang')].modals.connectionError.attemps} <span id='attemps'>1</span> / 10`);
                    setTimeout(() => {
                        modal.style.opacity = 1;
                    });
                }
            }
        };
        const closeModal = () => {
            const modals = document.getElementsByClassName('modal');
            for (const i in modals) {
                if (typeof (modals[i]) == 'object' && modals[i].id === 'modalSocket') {
                    const modal = modals[i];
                    modal.style.backgroundColor = 'rgba(0,0,0,0)';
                    modal.style.display = 'none';
                    setTimeout(() => {
                        modal.style.opacity = 0;
                    });
                }
            }
        };
        openModal();
        const callback = (n) => {
            if (socket.connected) {
                socket.emit(events.PING, socket.id, readCookie('_asid').split(',')[0]);
                if (ModuleRP.userName) {
                    ModuleRP.loadGame(ModuleRP.gameId);
                }
                _setText('modalSocket-body', `<h5 class='text-success'>${locales[readCookie('lang')].modals.connectionError.success}</h5>`);
                setTimeout(() => closeModal(), 3000);
            } else if (n >= 10) {
                alert('Module is offline');
            } else {
                socket.connect();
                n++;
                _setText('attemps', n);
                setTimeout(() => callback(n), 5000);
            }
        };
        setTimeout(() => callback(1), 5000);
        socket.connect();
    });

    /*
    ** Module Role Play
    */
    socket.on(events.LOBBY, (parties) => {
        if (_$('modalRpClose')) _$('modalRpClose').click();
        ModuleRP.setData(parties);
        ModuleRP.setPage('MyLobby');
    });

    socket.on(events.NOT_A_PLAYER, (parties) => {
        ModuleRP.setData(parties);
        ModuleRP.setPage('Lobby');
    });

    socket.on(events.LISTE_PARTIES, (parties) => {
        ModuleRP.setData(parties);
        ModuleRP.setPage('Lobby');
    });

    socket.on(events.NEW_GAME_NAME_USED, () => {
        ModuleRP.newGameNameUsed();
    });

    socket.on(events.NEW_GAME, (game) => {
        ModuleRP.newGameCreatedSuccess(game);
    });

    socket.on(events.LOAD_GAME, (game, userId) => {
        ModuleRP.startGame(game, userId);
    });

    socket.on(events.DELETE_GAME, () => {
        NotificationManager.success(locales[readCookie('lang')].notifications.deletedGame, '', 3000);
        ModuleRP.refreshList();
    });

    socket.on(events.REQUEST_JOIN_GAME, () => {
        NotificationManager.success(locales[readCookie('lang')].notifications.requestJoinGame, '', 3000);
        ModuleRP.setPage('Logo', 'Chargement');
        socket.emit(events.LISTE_PARTIES);
    });

    socket.on(events.CANCEL_REQUEST_JOIN_GAME, () => {
        NotificationManager.success(locales[readCookie('lang')].notifications.cancelRequestJoinGame, '', 3000);
        ModuleRP.setPage('Logo', 'Chargement');
        socket.emit(events.LISTE_PARTIES);
    });

    socket.on(events.NOT_ADMIN, () => {
        NotificationManager.error(locales[readCookie('lang')].notifications.notAdmin, 'Erreur', 3000);
    });

    socket.on(events.CONFIGURE, (game, sigData) => {
        ModuleRP.setConfiguration(game, sigData);
    });

    socket.on(events.NOTIFICATION_SUCCESS, (notif) => {
        NotificationManager.success(locales[readCookie('lang')].notifications[notif], '', 3000);
    });

    socket.on(events.NOTIFICATION_ERROR, (notif, err) => {
        NotificationManager.error(`${locales[readCookie('lang')].notifications[notif]}\n${err ? err : ''}`, '', 3000);
    });

    socket.on(events.MANAGE_BUILDING, (data) => {
        ModuleRP.setData(data);
    });

    socket.on(events.MANAGE_PLAYER, (player) => {
        ModuleRP.setData(player);
    });

    socket.on(events.MANAGE_VEHICLE_MODEL, (vehicleModel) => {
        ModuleRP.setData(vehicleModel);
    });

    socket.on(events.EDIT_VEHICLE_MODEL, (vehicleModel) => {
        ModuleRP.setData(vehicleModel);
        _$('btn-confirm-update-vehicleModel').disabled = false;
        _setText('btn-confirm-update-vehicleModel', locales[readCookie('lang')].config.update);
    });

    socket.on(events.MANAGE_RANK, (rank) => {
        ModuleRP.setData(rank);
    });

    socket.on(events.EDIT_RANK, (rank) => {
        ModuleRP.setData(rank);
        _$('btn-confirm-update-rank').disabled = false;
        _setText('btn-confirm-update-rank', locales[readCookie('lang')].config.update);
    });

    socket.on(events.MANAGE_STATUS, (status) => {
        ModuleRP.setData(status);
    });

    socket.on(events.EDIT_STATUS, (status) => {
        ModuleRP.setData(status);
        _$('btn-confirm-update-status').disabled = false;
        _setText('btn-confirm-update-status', locales[readCookie('lang')].config.update);
    });

    socket.on(events.MANAGE_SERVICE, (service) => {
        ModuleRP.setData(service);
    });

    socket.on(events.EDIT_SERVICE, (service) => {
        ModuleRP.setData(service);
        _$('btn-confirm-update-service').disabled = false;
        _setText('btn-confirm-update-service', locales[readCookie('lang')].config.update);
    });

    socket.on(events.MANAGE_SKILL, (skill) => {
        ModuleRP.setData(skill);
    });

    socket.on(events.EDIT_SKILL, (skill) => {
        ModuleRP.setData(skill);
        _$('btn-confirm-update-skill').disabled = false;
        _setText('btn-confirm-update-skill', locales[readCookie('lang')].config.update);
    });
    /* Config Functions */
    socket.on(events.MANAGE_FUNCTION, (_function) => {
        ModuleRP.setData(_function);
    });

    socket.on(events.EDIT_FUNCTION, (_function) => {
        ModuleRP.setData(_function);
        _$('btn-confirm-update-function').disabled = false;
        _setText('btn-confirm-update-function', locales[readCookie('lang')].config.update);
    });
    /*
    ** Connexion
    */
    socket.on(events.SESSION_OK, (pseudo, cle, serveur) => {
        session.validUser(pseudo, cle);
    });

    socket.on(events.SESSION_INVALID, () => {
        session.invalidUser();
    });

    socket.on(events.CONNEXION_OK, (userName, key, persist) => {
        session.validConnexion(userName, key, persist);
    });

    socket.on(events.INFOS_SESSION_INVALID, () => {
        NotificationManager.error(`Le nom d'utilisateur ou le mot de passe est erroné.`, 'Erreur', 3000);
    });

    socket.on(events.BANNED_ACCUNT, () => {
        NotificationManager.error(`Ce compte a été banni.`, 'Erreur', 3000);
    });

    socket.on(events.ACTIVATION_NEEDED, () => {
        NotificationManager.error(`Le compte n'a pas encore été activé. Un mail vous a été envoyé, vérifiez dans vos SPAMS.`, 'Erreur', 5000);
    });

    /*
    ** Mot de passe oublié
    */
    socket.on(events.FORGOT_PWD, () => {
        NotificationManager.success(`Un mail vient d'être envoyé à l'adresse associé au compte. Pensez à vérifier dans les SPAMS.`,
            'Demande de mot de passe oublié', 5000);
        document.getElementById('modalClose').click();
    });

    socket.on(events.FORGOT_PWD_USERNAME_UNKNOW, () => {
        NotificationManager.error(`Aucun utilisateur connu sous ce nom.`, 'Demande de mot de passe oublié', 5000);
    });

    socket.on(events.FORGOT_PWD_MAIL_SEND, () => {
        NotificationManager.error(`Un mail a déjà été envoyé pour ce compte.`, 'Demande de mot de passe oublié', 5000);
    });

    /* Inscription */
    socket.on(events.INSCRIPTION_MAIL_USED, () => {
        NotificationManager.error(`Cette adresse mail est déjà utilisée pour un autre compte.`, 'Inscription', 5000);
    });

    socket.on(events.INSCRIPTION_USERNAME_USED, () => {
        NotificationManager.error(`Ce nom de compte est déjà utilisée pour un autre compte.`, 'Inscription', 5000);
    });

    socket.on(events.INSCRIPTION_CODE_INVALID, () => {
        NotificationManager.error(`Ce code de parrainage n'existe pas.`, 'Inscription', 5000);
    });

    socket.on(events.INSCRIPTION_OK, () => {
        NotificationManager.success(`Un mail d'activation va vous être envoyé. Pensez à vérifier les SPAMS.`, 'Inscription réussie', 5000);
        document.getElementById('modalClose').click();
    });

    /*
    ** GestAd
    */
    socket.on(events.IS_ADMIN, () => {
        // document.getElementById('validAd').innerHTML = '<button class="btn btn-sm btn-success">Administration</button>';
    });

    /*
    ** Boutique
    */
    socket.on(events.SHOP, (gameOptions, listOptions) => {
        ModuleRP.setShop(gameOptions, listOptions);
    });

    /**
     * Assignments
    */
    socket.on(events.ASSIGNMENTS, (data) => {
        if (ModuleRP.page !== 'Assignments') return;
        ModuleRP.setData(data);
    });

    /**
     * SGA
    */
    socket.on(events.SGA, (data, incidentsCategories, places) => {
        if (ModuleRP.page !== 'Sga') return;
        data.incidentsCategories = incidentsCategories;
        data.places = places;
        ModuleRP.setData(data);
    });

    /**
     * SGO
    */
    socket.on(events.SGO, (data, dispatchOn) => {
        if (ModuleRP.page !== 'Sgo') return;
        ModuleRP.activeMission = dispatchOn;
        ModuleRP.setData(data);
    });

    socket.on(events.FAILURE_ENGAGEMENT, (failureMessages) => {
        if (ModuleRP.page !== 'Sgo') return;
        ModuleRP.setAlert(failureMessages);
    });

    /**
     * BIP
    */
    socket.on(events.BIP_MESSAGE, (message) => {
        ModuleRP.Bip.newMessage(message);
    });
    socket.on(events.BIP_ALERT, (message) => {
        ModuleRP.Bip.newAlert(message);
    });
    /**
     * RADIO
     */
    socket.on(events.RADIO_ON, () => {
        ModuleRP.Radio.init();
    });
    socket.on(events.RADIO_SEND_STATUS, (res) => {
        ModuleRP.Radio.statusSent(res);
    });
    socket.on(events.RADIO_MESSAGE, (message) => {
        ModuleRP.Radio.newMessage(message);
    });
};
export default socketManage;
